export default class AboutVideo {

  constructor(el) {
    this.$el = el;
    this.$video = this.$el.querySelector('.about-header__video-element');
    this.$playBtn = this.$el.querySelector('.about-header__video-button');

    this.$playBtn.addEventListener('click', () => {
      this.$video.currentTime = 0;
      this.$video.muted = false;
      this.$video.controls = true;
      this.$video.play();
      this.$playBtn.style.display = 'none';
    });

  }

}
